<template>
  <el-dialog
    title="上传文件"
    :visible.sync="value.visible"
    width="700px"
    :destroy-on-close="true"
    append-to-body
    @open="onDlgOpen"
    @closed="onDlgClosed"
  >
    <el-upload
      class="upload-demo"
      drag
      multiple
      :headers="headerObj"
      :action="params.actionUrl"
      :limit="params.limit"
      :file-list="fileList"
      :show-file-list="false"
      :before-upload="beforeUpload"
      :on-progress="onProgress"
      :on-change="onChange"
      :on-success="onSuccess"
    >
      <div class="el-icon--upload"><i class="iconfont icon-cloud-upload" style="font-size: 48px;" /></div>
      <div class="el-upload__text">拖放文件到这里 或 <em>点击上传</em></div>
      <div slot="tip" class="el-upload__tip" />
    </el-upload>
    <div>
      <div v-for="(item, index) of fileList" :key="index" class="row-start my-1">
        <div>{{ item.name }} </div>
        <div class="grow" />
        <div class="cursor-hand" :title="item.response ? item.response.msg : ''" v-html="renderResult(item)" />
      </div>
    </div>
  </el-dialog>

</template>

<script>
import { getToken } from '@/utils/auth'
import { humanFileSize } from '@/utils/index'

export default {
  name: 'DlgUpload',
  components: {
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        visible: false
      })
    },
    params: {
      type: Object,
      default: () => ({
        actionUrl: '',
        limit: 10000,
        maxSize: 100 * 1000 * 1000 * 1000, // 100G
        type: null // 全部
      })
    }
  },
  emits: ['ok', 'cancel'],
  data() {
    return {
      headerObj: {},
      fileList: []
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
    console.log(this.value)
  },

  methods: {
    async onDlgOpen() {
      const that = this
      const token = getToken()
      that.headerObj = { 'Authorization': `Bearer ${token}` }

      that.fileList = []
    },
    onDlgClosed() {
      console.log(this.fileList)
      const list = this.fileList.filter((file) => {
        if (file.response && file.response.status === 200) {
          return file
        }
      })
      this.$emit('closed', list.length > 0)
    },
    beforeUpload(file) {
      const that = this
      if (this.params.type) {
        if (!file.type.includes(this.params.type)) {
          that.$message({
            type: 'error',
            message: '文件类型错误',
            center: true
          })
          return false
        }
      }
      if (file.size > this.params.maxSize) {
        that.$message({
          type: 'error',
          message: '文件大小不能超过 ' + humanFileSize(that.params.maxSize),
          center: true
        })
        return false
      }
    },
    onProgress(event, file, fileList) {
      console.log(event, file, fileList)
      console.log(this.fileList)
      this.fileList = fileList.slice()
    },
    onChange(file, fileList) {
      this.fileList = fileList.slice()
    },
    onSuccess(res, file, fileList) {
      console.log(res, file, fileList)
      console.log(this.fileList)
      this.$emit('success', res, file, fileList)
    },
    renderResult(item) {
      let result = ''
      if (!item.response) {
        const percent = parseInt(item.percentage)
        result = `${percent}%`
        return result
      }
      switch (item.response.status) {
        case 200:
          result = `<span class=has-text-success>成功</span>`
          break
        case 422:
          result = `<span class=has-text-danger>失败，${item.response.body[0].message}</span>`
          break
        default:
          result = `<span class=has-text-danger>失败，${item.response.message}</span>`
          break
      }
      return result
    },
    onCancel() {
      console.log('cancel')
      this.value.visible = false
      this.$emit('cancel')
    },
    async onOk() {
      // const that = this
      console.log('ok')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
::v-deep {
  .el-upload  {
    width: 100%;

    .el-upload-dragger {
      width: 100%;
      height: 180px;
      padding-top: 50px;
    }
  }
}
</style>
